import { render, staticRenderFns } from "./tablaProductos.vue?vue&type=template&id=50b03c3b&scoped=true&"
import script from "./tablaProductos.vue?vue&type=script&lang=js&"
export * from "./tablaProductos.vue?vue&type=script&lang=js&"
import style0 from "./tablaProductos.vue?vue&type=style&index=0&id=50b03c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b03c3b",
  null
  
)

export default component.exports